import { specialCharsRegex, specialCharsRegexMessage } from 'shared/utils/regex'
import * as yup from 'yup'

export const schema = yup.object({
    media: yup.string().required().matches(specialCharsRegex, specialCharsRegexMessage),
    file: yup.mixed().required(),
})
